<script>
  import { Group, Text, Block } from 'bastone'
  import MyButton from './button.svelte'
  import Confirm from './confirm.svelte'
  import { DataSet } from '../models'
  import { notify, isDesktop } from '../context'


  //export let row = {}
  export let rows = []
  export let rowNo = -1
  // svelte-ignore unused-export-let
  export let value = null
  let confirm = null

  $: row = rows[rowNo]

  let oldRow = null
  function edit() {
    if (row._editing) return
    oldRow = new DataSet({...row._data})
    rows[rowNo]._editing = true

  }

  async function save() {
    if (!row._editing) return
    if (row.content.length <= 0 || row.content.length > 4096) {
      notify('内容无效或长度超限', 'error')
      return
    }
    let ok = row.id ? await row.update() : await row.create()
    if (!ok) return
    rows[rowNo]._editing = false
  }

  function cancel() {
    if (!row._editing) return
    if (!row.id) {
      // remove row
      rows.splice(rowNo, 1)
      rows = rows
      return 
    }
    oldRow._editing = false
    rows[rowNo] = oldRow
  }

  function deleteRow() {
    confirm.show(`确定删除Id:${row.id}的数据吗？`, async()=>{
      if (row.id) {
        let ok = await row.delete()
        if (!ok) return
      }
      rows.splice(rowNo, 1)
      rows = rows
    })
  }

</script>


<Confirm bind:this={confirm}/>

<Group width=100% align=center xAlign=center direction={$isDesktop?'row':'column'}>
  {#if !row._editing}
  <Text 
    decoration=underline cursor=pointer selectable={false} size=0.9rem
    on:click={edit}
  >编辑</Text>
  <Block width=0.6rem/>
  <Text 
    decoration=underline cursor=pointer selectable={false} size=0.9rem
    on:click={deleteRow}
  >删除</Text>
  {:else}
  <MyButton 
    border=1 fontSize=0.8rem fill=1 width=2.5rem height=1.4rem
    on:click={save}
  >保存</MyButton>
  <Block width=0.4rem height=0.4rem/>
  <MyButton 
    border=1 fontSize=0.8rem width=2.5rem height=1.4rem
    on:click={cancel}
  >取消</MyButton>
  {/if}
</Group>


